<ion-header>
    <ion-toolbar>
        <ion-title>Photo List</ion-title>
        <ion-buttons slot="start">
            <ion-button (tap)="cancelModal()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>


    <ion-row *ngIf="isAndroid()">        
            <ion-col size="6">
        <!--        <input class="ion-button" type="file" id="pwaphoto" #pwaphoto accept="image/*" multiple (change)="uploadPWA($event)">-->
                <ion-button id="gallery" expand="full" color="light" type="file" shape="round" (click)="openGallery()">Gallery
                    <ion-icon slot="end" name="images"></ion-icon>
                </ion-button>
            </ion-col>
            <ion-col size="6">
                <ion-button expand="full" color="light" (click)="takePicture()" shape="round">
                    Camera
                    <ion-icon slot="end" name="camera"></ion-icon>
                </ion-button>
            </ion-col>
    </ion-row>
    <ion-row *ngIf="!isAndroid()">
        <ion-col size="4"></ion-col>
        <ion-col size="4">
            <ion-button id="gallery" expand="full" color="light" type="file" shape="round" (click)="openGallery()">Add Photos
                <ion-icon slot="end" name="images"></ion-icon>
            </ion-button>
        </ion-col>
        <ion-col size="4"></ion-col>
    </ion-row>
    
    <div id="pwaCamera" style="visibility: hidden; width: 0px">
        <input type="file" id="pwaphotoCamera" #pwaphotoCamera accept="image/*" (change)="captureImagePWA($event)" capture="camera">
    </div>
    <div id="pwaGallery" style="visibility: hidden; width: 0px">
            <input type="file" id="pwaphotoGallery"  #pwaphotoGallery accept="image/*" (change)="captureGalleryPWA($event)" multiple>
    </div>

<!--<ion-row>-->
<!--    <ion-col size="6">-->
<!--        <input type="file" id="pwaphoto" #pwaphoto accept="image/*" capture="camera" (change)="uploadPWA($event)">-->
<!--    </ion-col>-->
<!--</ion-row>-->

<ion-content>
    <ion-list>
        <ion-item-sliding *ngFor="let img of document.photosURL; index as pos">
            <ion-item>
                <ion-card >
                    <ion-img [src]=img.photoBase64></ion-img>
                    <ion-card-content>
                        <p (press)="handleEditPhoto(img)" *ngIf="img.comment.length > 0" style="white-space: pre-line;">{{img.comment}}   </p>
                        <p (press)="handleEditPhoto(img)" *ngIf="img.comment.length === 0" style="white-space: pre-line;">Long Press to add a comment </p>
                                        
                    </ion-card-content> 
                   
                </ion-card>
            </ion-item>
            <ion-item-options side="end">
                <ion-item-option color="none" class="ion-float-right">
                    <ion-button color="danger" (click)="removeImg(img, pos)">
                        <ion-icon name="trash" slot="icon-only" size="big"></ion-icon>
                    </ion-button>
                </ion-item-option>
            </ion-item-options>
        </ion-item-sliding>
    </ion-list>
</ion-content>

<ion-footer *ngIf="document.photosURL.length > 0" >
    <p class="ion-text-center" style="color: darkgrey">Slide picture left to delete</p>
    <p class="ion-text-center" style="color: darkgrey">The images are saved automatically</p>
    
</ion-footer>
